<template>
  <v-layout :style="style">
    <v-flex xs12 class="text-xs-center" style="padding-bottom: 700px;">
      <v-progress-circular
        :size="50"
        :width="3"
        color="amber"
        indeterminate
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'MyLoader',

  props: {
    spacing: {
      type: Number,
      default: 0
    }
  },

  computed: {
    style () {
      return {
        padding: this.spacing + 'px 0',
        width: '100%'
      }
    }
  }
}
</script>
